<template>
  <el-dialog
    :title="'编辑表单项'"
    :visible.sync="signupDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="800px"
    center
  >
    <el-form
      :model="signupForm"
      :rules="rules"
      ref="signupForm"
      label-width="100px"
    >
      <el-form-item label="表单类型" prop="type">
        <el-radio-group v-model="signupForm.type">
          <el-radio label="1">单行文本</el-radio>
          <el-radio label="2">多行文本</el-radio>
          <el-radio label="3">单选题</el-radio>
          <el-radio label="4">多选题</el-radio>
          <el-radio label="5">附件上传</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="标题" prop="name">
        <el-input v-model="signupForm.name" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-radio-group v-model="signupForm.state">
          <el-radio label="1">必填</el-radio>
          <el-radio label="0">非必填</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="默认值"
        prop="option"
        v-if="Number(signupForm.type) === 3 || Number(signupForm.type) === 4"
      >
        <el-input
          type="textarea"
          v-model="signupForm.option"
          placeholder="单选多选默认值格式:[ 男/女/未知 ] 选项用 / 分开 "
        ></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('signupForm')"
          >取消</el-button
        >
        <el-button
          class="padding-lr-xl"
          type="primary"
          @click="submitForm('signupForm')"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>


export default {
  name: "signupDialog",
  props: {
    signupDialog: {
      type: Boolean,
      default: false
    },
    setIndex: {
      type: Number,
      default () {
        return -1;
      }
    },
    setItem: {
      type: Object
    }
  },
  data () {
    return {
      signupForm: {
        type: '1',
        name: '',
        state: '1',
        option: '',

      },
      rules: {
        type: [
          { required: true, message: '请选择类型', trigger: 'change' },
        ],
        name: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        state: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
        option: [
          { required: true, message: '请输入默认值', trigger: 'blur' },
        ],
      },
    }
  },
  created () {
  },
  methods: {
    resetForm (formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', [false, ''])
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    submitData (formName) {
      let _option = ''
      if (Number(this.signupForm.type) === 3 || Number(this.signupForm.type) === 4) {
        if (!this.signupForm.option) return this.$message.error('选择题需填写默认值')
        let _val = JSON.parse(JSON.stringify(this.signupForm.option))
        let _arr = _val.split('/')
        _option = _arr
      }
      this.$emit("cancelDialog", [true, JSON.parse(JSON.stringify({
        type: this.signupForm.type,
        name: this.signupForm.name,
        state: this.signupForm.state,
        option: _option,
        value: Number(this.signupForm.type) === 4?[]:''
      }))]);
      this.$refs[formName].resetFields();
    }

  },
  watch: {
    setItem () {
      let _str = ''
      if (this.setItem.option && this.setItem.option.length>0) {
        _str = this.setItem.option.join('/')
      }
      this.signupForm = {
        type: this.setItem.type ? this.setItem.type.toString() : '1',
        name: this.setItem.name,
        state: this.setItem.state ? this.setItem.state.toString() : '1',
        option: _str,
      };
    }
  }
}
</script>

<style scoped lang="scss">
</style>